import AuthManager from "Common/AuthManager";
import ServiceWrapper from "Services/ServiceWrapper";
import AppSettings from "Settings/AppSettings";
import reactSelect from "react-select";
import { TFilters } from "types/hooks/useTable";

const api_base_url = AppSettings.GMS_BACKEND_API_URL;

function generateFiltersFromObject(filters?: TFilters|null) {
    if(!filters) return 

    return Object.keys(filters)
    .filter((key) => !!filters[key])
    .map(key => key + '=' + (typeof filters[key] !== 'object' ? filters[key] : (filters[key].toString()))).join('&')
}

export async function listProductsByCategoryId(categoryId: string, filters?: TFilters|null) {
    try{
        if(!categoryId) throw new Error("No category id specified for listing products")

        // generate filters
        const _filters = generateFiltersFromObject(filters)
        
        // call api
        let res = await ServiceWrapper.doGet(
            `${api_base_url}product/variants/${categoryId}${_filters ? `?${_filters}` : ""}`,
            null,
            null,
            AuthManager.getGmsToken()
        );

        // error check
        if(res?.errorfound || !res.data?.data) throw new Error("Product fetch failed : " + (res?.data?.message ? res.data.message : "Unexpected error"))
        
        return res?.data
    }
    catch(err: any) {
        console.error((err.message), 4)
        return Promise.reject(new Error(err.message))
    }
  }

  export async function listChildProductsByParentId(parentId: string) {
    try{
        if(!parentId) throw new Error("No parent id specified for listing products")

        // call api
        let res = await ServiceWrapper.doPost(
            `${api_base_url}get_variants/${parentId}`,
            {},
            null,
            AuthManager.getGmsToken()
        );
        
        // error check
        if(res?.errorfound || !res.data?.data) throw new Error("Product fetch failed : " + (res?.data?.message ? res.data.message : "Unexpected error"))
        
        return {
            count: res.data.count,
            data: res.data.data,
        }
    }
    catch(err: any) {
        console.error((err.message), 4)
        return Promise.reject(new Error(err.message))
    }
  }